var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-notice-form',{ref:"form",staticClass:"pt-notice-form__withData",attrs:{"isEdit":_vm.isEdit,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }